// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2yDta","notes":"Notes_notes__3x7VE","note":"Notes_note__3Wtbv","markdown":"Notes_markdown__10UVu"};